import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const CategoriesContext = createContext({ categories: [], loading: true, refresh: () => {} });

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/categories");
      setCategories(data);
    } catch {
      // keep current
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <CategoriesContext.Provider value={{ categories, loading, refresh }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export const useCategories = () => useContext(CategoriesContext);

export const LANG_LABEL = { fr: "FR", creole: "Créole", en: "EN" };

export const LEGAL_DISCLAIMER =
  "Nos contenus sont purement éducatifs, destinés à informer et à sensibiliser. Nous ne promouvons ni n'incitons à la consommation de cannabis.";

export function useCategoryBySlug(slug) {
  const { categories } = useCategories();
  return categories.find((c) => c.slug === slug);
}
